import React from 'react';
import { Box } from '@chakra-ui/react';
import { motion, AnimatePresence } from 'framer-motion';

const MotionBox = motion(Box);

export default function AnimatedBackground({ isVisible }) {
  return (
    <AnimatePresence>
      {isVisible && (
        <>
          {[...Array(6)].map((_, i) => (
            <MotionBox
              key={i}
              position="absolute"
              w="4px"
              h="4px"
              bg="whiteAlpha.400"
              borderRadius="50%"
              initial={{
                x: Math.random() * 600,
                y: Math.random() * 300,
                opacity: 0,
              }}
              animate={{
                x: Math.random() * 600,
                y: Math.random() * 300,
                opacity: [0, 1, 0],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                delay: i * 0.5,
                ease: 'easeInOut',
              }}
            />
          ))}
        </>
      )}
    </AnimatePresence>
  );
}
